import { isNumeric } from "ui/display-number/display-number";

// As suggested in https://www.w3.org/TR/AERT/#color-contrast
export const brightness = (r, g, b) => {
  return (r * 299 + g * 587 + b * 114) / 1000;
};

export const numericColorToRgb = (color: number) => {
  color >>>= 0;
  return { 
    r: (color & 0xFF0000) >>> 16,
    g: (color & 0xFF00) >>> 8,
    b: color & 0xFF
  };
};
/* eslint:enable */

export const numericColorBrightness = (color: number) => {
  const asRgb = numericColorToRgb(color);
  return brightness(asRgb.r, asRgb.g, asRgb.b);
};

const hexToDigit = (num: number) => {
  let str = num.toString(16);
  if (str.length < 2) {
    str = '0' + str;
  }
  return str;
};

export const convertNumericColorToHex = (color: number, a?: number) => {
  if (!isNumeric(color)) {
    return undefined;
  }
  const asRgb = numericColorToRgb(color);
  return `#${hexToDigit(asRgb.r)}${hexToDigit(asRgb.g)}${hexToDigit(asRgb.b)}${typeof a === 'number' ? hexToDigit(a) : ''}`;
};

export const hexColorToNumeric = (color: string) => {
  const hex = color.replace(/^#/, '');
  if (hex.length === 3) {
    return parseInt(
      `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`,
      16
    );
  } else if (hex.length === 6) {
    return parseInt(hex, 16);
  }
  return 16777215; // return white color as default
};
